export var SERVICE_SUSPENSION_TYPES = {
  NETWORK: 1,
  NETWORK_AND_BILLING: 2
};
export var SERVICE_FEATURE_ADD_ON_DESCRIPTION_OPTIMAL_CHAR_COUNT = 360;